import { render, staticRenderFns } from "./MentoriaBruno.vue?vue&type=template&id=97a60544&scoped=true"
import script from "./MentoriaBruno.vue?vue&type=script&lang=js"
export * from "./MentoriaBruno.vue?vue&type=script&lang=js"
import style0 from "./MentoriaBruno.vue?vue&type=style&index=0&id=97a60544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a60544",
  null
  
)

export default component.exports